var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modals.length>0)?_c('v-overlay',[_c(_vm.modal.type,{tag:"component",attrs:{"params":_vm.modal.params},on:{"closed":_vm.closed}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }